<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadRingGroups(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addRingGroup">{{ $t('add_ring_group') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :placeholder="$t('company_name')" v-model="ringGroupSearchParams.company" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :placeholder="$t('ring_group')" v-model="ringGroupSearchParams.ringGroup" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :placeholder="$t('ring_name')" v-model="ringGroupSearchParams.ringName" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadRingGroups(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="ringGroupDataContainer" :title="$t('ring_group')" class="mb-8 vs-con-loading__container">
      <vs-table hover-flat v-if="ringGroups && ringGroups.length" :data="ringGroups">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('company_name')"></vs-th>
          <vs-th v-text="$t('ring_group')"></vs-th>
          <vs-th v-text="$t('ring_name')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.company_name"></vs-td>
            <vs-td>
              <badge-clipboard :text="tr.group"></badge-clipboard>
            </vs-td>
            <vs-td v-text="tr.name"></vs-td>
            <vs-td>
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click="editRingGroup(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click="deleteRingGroup(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="ringGroupPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadRingGroups"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_ring_group')" :active.sync="modals.add" size="md">
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('company')"></label>
        <v-select :options="companyOptions" :reduce="label => label.value" :placeholder="$t('company')" v-model="ringGroupFormData.company_id" class="md:mb-0" />
        <validation-error :model-error="ringGroupFormErrors.company_id"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('groups')" :placeholder="$t('groups')" v-model="ringGroupFormData.group" class="w-full"/>
        <validation-error :model-error="ringGroupFormErrors.group"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="ringGroupFormData.name" class="w-full"/>
        <validation-error :model-error="ringGroupFormErrors.name"></validation-error>
      </div>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addRingGroupButton" color="primary" type="filled" @click.prevent="submitRingGroup">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_ring_group')" :active.sync="modals.edit" size="md">
      <div id="ringGroupEditFormDataContainer" class="vs-con-loading__container">
        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('company')"></label>
          <v-select :options="companyOptions" :reduce="label => label.value" :placeholder="$t('company')" v-model="ringGroupFormData.company_id" class="md:mb-0" />
          <validation-error :model-error="ringGroupFormErrors.company_id"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('groups')" :placeholder="$t('groups')" v-model="ringGroupFormData.group" class="w-full"/>
          <validation-error :model-error="ringGroupFormErrors.group"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="ringGroupFormData.name" class="w-full"/>
          <validation-error :model-error="ringGroupFormErrors.name"></validation-error>
        </div>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editRingGroupButton" color="primary" type="filled" @click.prevent="updateRingGroup">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import RingGroup from '@/models/RingGroup'

export default {
  name: 'Admin.RingGroup',
  mixins: [Pagination],
  components: {
    Paginate,
    Modal
  },
  data () {
    return {
      ringGroups: {},
      ringGroupPages: 0,
      companyOptions: [],
      ringGroupFormData: {
        company_id: '',
        group: '',
        name: ''
      },
      ringGroupFormErrors: [],
      ringGroupSearchParams: {
        company: '',
        ringGroup: '',
        ringName: ''
      },
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetRingGroupForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetRingGroupForm()
      }
    }
  },
  mounted () {
    this.loadRingGroups(this.initialPage, null)
  },
  methods: {
    async loadRingGroups (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#ringGroupDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await RingGroup.all({ ...this.ringGroupSearchParams, page, itemPerPage })
      this.ringGroups = response.data.data.ringGroups
      this.ringGroupPages = response.data.meta.pagination.last_page
      this.companyOptions = response.data.meta.options.companies
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#ringGroupDataContainer > .con-vs-loading')
    },
    addRingGroup () {
      this.modals.add = true
    },
    async submitRingGroup () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addRingGroupButton', scale: 0.45})

      try {
        const response = await RingGroup.store(this.ringGroupFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadRingGroups(1, null)
        this.resetRingGroupForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.ringGroupFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addRingGroupButton > .con-vs-loading')
    },
    async editRingGroup (id) {
      this.$vs.loading({container: '#ringGroupEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await RingGroup.view({ id })
        this.ringGroupFormData = response.data.ringGroup
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#ringGroupEditFormDataContainer > .con-vs-loading')
    },
    async updateRingGroup () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editRingGroupButton', scale: 0.45})

      try {
        const response = await RingGroup.update(this.ringGroupFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadRingGroups()
        this.resetRingGroupForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.ringGroupFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editRingGroupButton > .con-vs-loading')
    },
    async deleteRingGroup (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await RingGroup.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadRingGroups(1, null)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    resetRingGroupForm () {
      this.ringGroupFormData = {
        company_id: '',
        group: '',
        name: ''
      }
      this.ringGroupFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addRingGroupButton,
  #editRingGroupButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
